import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "error-notifications-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_5 = {
  key: 0,
  class: "h-100 overflow-y-auto"
}
const _hoisted_6 = ["data-form-index"]
const _hoisted_7 = ["src", "height", "onLoad"]
const _hoisted_8 = {
  key: 1,
  class: "text-caption pa-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_NetworkStatusBanner = _resolveComponent("NetworkStatusBanner")!
  const _component_UserNotification = _resolveComponent("UserNotification")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_GhostDraftView = _resolveComponent("GhostDraftView")!
  const _component_v_stepper_window_item = _resolveComponent("v-stepper-window-item")!
  const _component_Mbtn = _resolveComponent("Mbtn")!
  const _component_v_stepper_window = _resolveComponent("v-stepper-window")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_stepper_actions = _resolveComponent("v-stepper-actions")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WaitDialog, {
      isActive: $setup.isWaiting,
      title: $setup.statusMessage || $setup.waitTitle
    }, null, 8 /* PROPS */, ["isActive", "title"]),
    _createVNode(_component_v_container, {
      fluid: "",
      class: "pa-4"
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" Network disruption warning "),
        _createVNode(_component_NetworkStatusBanner, { message: "A network interruption was detected. Form generation may have stopped. Please refresh the page to continue." }),
        _createCommentVNode(" Error Messages Row "),
        ($setup.errorMessages.length)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.errorMessages, (error, index) => {
                        return (_openBlock(), _createBlock(_component_UserNotification, {
                          key: index,
                          message: error.content,
                          closable: true
                        }, null, 8 /* PROPS */, ["message"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Interactive Forms Stepper Row "),
        ($setup.showInteractiveForms)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_stepper, {
                      mobile: "",
                      modelValue: $setup.currentStep,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.currentStep) = $event)),
                      editable: ""
                    }, {
                      default: _withCtx(({ }) => [
                        _createCommentVNode(" Stepper Header "),
                        _createVNode(_component_v_stepper_header, { class: "pc" }, {
                          default: _withCtx(() => [
                            _createCommentVNode(" Steps for ghostDraftContent "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.interactiveForms, (content, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: `step-ghostDraftContent-${index}`
                              }, [
                                _createVNode(_component_v_stepper_item, {
                                  complete: $setup.currentStep > index + 1,
                                  step: index + 1,
                                  value: index + 1
                                }, {
                                  default: _withCtx(() => [
                                    _createCommentVNode(" Ghost Draft {{ index + 1 }} ")
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["complete", "step", "value"]),
                                (index < $setup.interactiveForms.length - 1)
                                  ? (_openBlock(), _createBlock(_component_v_divider, {
                                      key: `divider-ghostDraftContent-${index}`
                                    }))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createCommentVNode(" Final Step "),
                            _createVNode(_component_v_stepper_item, {
                              complete: $setup.currentStep > $setup.totalSteps,
                              step: $setup.totalSteps,
                              value: $setup.totalSteps
                            }, {
                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode(" Submit ")
                              ])),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["complete", "step", "value"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createCommentVNode(" Stepper Window "),
                        _createVNode(_component_v_stepper_window, null, {
                          default: _withCtx(() => [
                            _createCommentVNode(" Render ghostDraftContent "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.interactiveForms, (item, index) => {
                              return (_openBlock(), _createBlock(_component_v_stepper_window_item, {
                                key: `content-ghostDraftContent-${index}`,
                                value: index + 1
                              }, {
                                default: _withCtx(() => [
                                  _createCommentVNode(" Render GhostDraftView for the current ghostDraftContent "),
                                  (item !== null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createVNode(_component_GhostDraftView, {
                                          ref_for: true,
                                          ref: "ghostDraftViewRef",
                                          formDetails: item
                                        }, null, 8 /* PROPS */, ["formDetails"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[4] || (_cache[4] = [
                                        _createElementVNode("p", null, "No template available for this GhostDraft content.", -1 /* HOISTED */)
                                      ]))]))
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createCommentVNode(" Final Step "),
                            _createVNode(_component_v_stepper_window_item, { value: $setup.totalSteps }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "d-flex justify-center align-center h-100",
                                  style: {"min-height":"300px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "mb-4" }, "Final Step", -1 /* HOISTED */)),
                                        _createVNode(_component_v_divider, { color: "success" }),
                                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "py-4" }, "Please review all data before submitting.", -1 /* HOISTED */)),
                                        _createVNode(_component_v_divider, { color: "success" }),
                                        _createVNode(_component_Mbtn, {
                                          class: "mt-5",
                                          color: "primary",
                                          onClick: $setup.handleSubmit
                                        }, {
                                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                                            _createTextVNode(" Submit")
                                          ])),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["value"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createCommentVNode(" Stepper Actions "),
                        ($setup.currentStep < $setup.totalSteps)
                          ? (_openBlock(), _createBlock(_component_v_stepper_actions, { key: 0 }, {
                              prev: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  disabled: !$setup.nextPrevEnabled,
                                  loading: $setup.isWaiting,
                                  onClick: _cache[0] || (_cache[0] = () => $setup.handlePrevStep())
                                }, {
                                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createTextVNode(" Previous Form ")
                                  ])),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled", "loading"])
                              ]),
                              next: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  disabled: !$setup.nextPrevEnabled,
                                  loading: $setup.isWaiting,
                                  onClick: _cache[1] || (_cache[1] = () => $setup.handleNextStep())
                                }, {
                                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createTextVNode(" Next Form ")
                                  ])),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled", "loading"])
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Generated Forms Row "),
        ($setup.showPolicyForms)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 2,
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "mb-4" }, "Forms", -1 /* HOISTED */)),
                    ($setup.generatedFormDetails.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.generatedFormDetails, (form, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: index,
                                onClick: ($event: any) => ($setup.scrollToForm(index)),
                                active: $setup.selectedFormIndex === index
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(form.formName), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "active"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : (_openBlock(), _createElementBlock("p", _hoisted_4, "No forms available"))
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, { cols: "9" }, {
                  default: _withCtx(() => [
                    ($setup.generatedFormDetails.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_v_tooltip, {
                            text: "Return to the interactive forms section to make edits",
                            location: "top"
                          }, {
                            activator: _withCtx(({ props }) => [
                              ($setup.policyFormsTracker?.hasInteractiveForms !== false && !$setup.policyFormsTracker?.isCompleted)
                                ? (_openBlock(), _createBlock(_component_Mbtn, _mergeProps({
                                    key: 0,
                                    class: "mb-2",
                                    color: "primary"
                                  }, props, { onClick: $setup.editInteractiveForms }), {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createTextVNode(" Edit Forms ")
                                    ])),
                                    _: 2 /* DYNAMIC */
                                  }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _cache[12] || (_cache[12] = _createTextVNode()),
                          _createVNode(_component_v_infinite_scroll, {
                            onLoad: $setup.loadMoreItems,
                            items: $setup.displayedForms,
                            height: "calc(100vh - 120px)",
                            class: "pdf-infinite-scroll"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedForms, (form, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  ref_for: true,
                                  ref: el => $setup.setFormRef(el, index),
                                  "data-form-index": index,
                                  class: "pdf-section mb-6"
                                }, [
                                  _createVNode(_component_v_card, {
                                    class: "mb-4 overflow-hidden",
                                    elevation: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_title, { class: "border-sm border-solid border-on-button-default bg-on-primary" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(form.formName), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_component_v_card_text, { class: "pa-0" }, {
                                        default: _withCtx(() => [
                                          (form.documentUrl)
                                            ? (_openBlock(), _createElementBlock("iframe", {
                                                key: 0,
                                                src: $setup.getPdfUrl(form.documentUrl),
                                                ref_for: true,
                                                ref: el => $setup.setPdfIframeRef(el, index),
                                                width: "100%",
                                                height: $setup.getPdfHeight(index),
                                                frameborder: "0",
                                                class: "pdf-iframe",
                                                onLoad: ($event: any) => ($setup.onPdfLoad(index))
                                              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_8, "No document URL available for this form"))
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ], 8 /* PROPS */, _hoisted_6))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["onLoad", "items"])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" PDF iframe removed - Ghost Draft handles document display internally ")
  ], 64 /* STABLE_FRAGMENT */))
}